import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  USERDASHBOARD: {
    path: `${baseRoutes.userBaseRoutes}home`,
  },
};

export default accessRoute;
